// Add InitialsAvatar component at the top of the file
export const InitialAvatar = ({ title, initial,radius=50, size = 65, borderWidth = 0 }) => {
    const getInitials = () => {
        if (!initial) {
            // If last name is blank, check first name
            if (title) {
                const words = title.trim().split(/\s+/);
                if (words.length >= 2) {
                    return `${words[0].charAt(0).toUpperCase()}${words[words.length - 1].charAt(0).toUpperCase()}`;
                }
                 else {
                    // If single word, get first and last letter
                    const word = words[0];
                    return `${word.charAt(0).toUpperCase()}${word.charAt(word.length - 1).toUpperCase()}`;
                }
            }
            return '';
        }
        // If last name exists, use original logic
        const Initial = initial ? initial.toUpperCase() : '';
        return `${Initial}`;
    };

    return (
        <div 
            className="initials-avatar"
            style={{
                width: size,
                height: size,
                borderRadius: `${radius}%`,
                backgroundColor: '#f1f7ff',
                borderWidth: `${borderWidth}px`,
                color: '#4491F5',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: `${size * 0.4}px`,
                fontWeight: 'normal',
                textTransform: 'uppercase'
            }}
        >
            {getInitials()}
        </div>
    );
};